import { AssistanceFormEnum } from "../../Constants/Constants";

export const genentechHubInsurance = (value, ctx) => {
    const primIns = 'Insurance Does Patient Have Primary Medical Insurance';
    const secIns = 'Insurance Does Patient Have Secondary Medical Insurance';
    const elig = 'Other GenentechHub Eligibilty Reason';

    if (!ctx.formData[primIns] || !ctx.formData[secIns] || !ctx.formData[elig]) return;

    if ((ctx.formData[primIns] === "No" && ctx.formData[secIns] === "No") && ctx.formData[elig] !== "No Insurance") {
        ctx.specialRuleChangeWarning(elig, "Because you indicated earlier that the patient does not have insurance, 'No Insurance' is the only valid answer.");
    } else {
        ctx.specialRuleChangeWarning(elig, "");
    }
}

export const genentechHubInsuredRelationToPatient = (value, ctx) => {
    const primRelation = "Insurance Primary Policy Holder Relationship to Patient";
    const primFN = "Insurance Primary Subscriber First Name";
    const primLN = "Insurance Primary Subscriber Last Name";
    const primDOB = "Insurance Primary Policy Holder Date of Birth";

    const secRelation = "Insurance Secondary Policy Holder Relationship to Patient";
    const secFN = "Insurance Secondary Subscriber First Name";
    const secLN = "Insurance Secondary Subscriber Last Name";
    const secDOB = "Insurance Secondary Subscriber Date of Birth";

    const patFN = "Patient Name First";
    const patLN = "Patient Name Last";
    const patDOB = "Patient DOB";

    if (ctx.formData[primRelation] === "self") {
        ctx.specialRuleChangeData(primFN, ctx.formData[patFN]);
        ctx.specialRuleChangeData(primLN, ctx.formData[patLN]);
        ctx.specialRuleChangeData(primDOB, ctx.formData[patDOB]);
        ctx.specialRulePerformAction("readonly", [primFN, primLN, primDOB]);
    } else {
        ctx.specialRulePerformAction("readwrite", [primFN, primLN, primDOB]);
    }

    if (ctx.formData[secRelation] === "self") {
        ctx.specialRuleChangeData(secFN, ctx.formData[patFN]);
        ctx.specialRuleChangeData(secLN, ctx.formData[patLN]);
        ctx.specialRuleChangeData(secDOB, ctx.formData[patDOB]);
        ctx.specialRulePerformAction("readonly", [secFN, secLN, secDOB]);
    } else {
        ctx.specialRulePerformAction("readwrite", [secFN, secLN, secDOB]);
    }
}

/*******************************************************
 Genentech Hub Attestation & Signatures Rules
 --------------------------------------------
 There's so many here becuase there are a bunch of rules that all affect required state of several signature fields based on the state of several other fields.
 However, the hidden state is controlled by the state of a different set of fields and the hidden vs required state must be toggled separately.
 tl;dr the db rules don't allow only changing hidden or required, but they set both at the same time.
 *******************************************************/
export const initVenclextaSpecialRule = (ctx) => {
    //only execute within Genentech form
    if (ctx.meta.formId !== AssistanceFormEnum.GenentechHub) return;
    const brand = ctx.meta.brandName.toLowerCase();
    if (brand !== 'venclexta' && brand !== 'gazyva' && brand !== 'rituxan') {
        venclextaSpecialRule(false, ctx);
        return;
    }
    else if (brand === 'venclexta') {
        venclextaSpecialRule(true, ctx)
    }
    else if (ctx.formData['GenentechHub Pharmacy Details'] === '') {
        venclextaSpecialRule(false, ctx);
    }
    else {
        var drugDetailList = [];
        if (ctx.formData['GenentechHub Pharmacy Details']) {
            drugDetailList = JSON.parse(ctx.formData['GenentechHub Pharmacy Details']);
            if (drugDetailList.length > 0) {
                var hasVenclexta = drugDetailList.some(drug => drug.drugName === 'Venclexta');
                venclextaSpecialRule(hasVenclexta, ctx);
            }
        }
    }

    //This rule is firing after render and special rules do not force a rerender by default
    ctx.__update(0);
}


export const venclextaSpecialRule = (isVenclextaIncluded, ctx) => {
    //only execute within Genentech form
    if (ctx.meta.formId !== AssistanceFormEnum.GenentechHub) return;

    var outsideConsentValue = ctx.formData['Signature Consent Outside of AssistPoint'];


    __doTheVenclextaLogic(isVenclextaIncluded, outsideConsentValue, ctx);
}

const hasVenclexta = (ctx) => {
    const brand = ctx.meta.brandName.toLowerCase();
    if (brand === 'venclexta') return true;

    var drugDetailList = [];
    if (ctx.formData['GenentechHub Pharmacy Details']) {
        drugDetailList = JSON.parse(ctx.formData['GenentechHub Pharmacy Details']);
        if (drugDetailList.length > 0) {
            var hasVenclexta = drugDetailList.some(drug => drug.drugName === 'Venclexta');
            if (hasVenclexta) return true;
        }
    }

    return false;
}

export const genentechHubSignatures = (value, ctx) => {
    const outsideConsentValue = value;
    const includesVenclexta = hasVenclexta(ctx);

    __doTheVenclextaLogic(includesVenclexta, outsideConsentValue, ctx);
}

const __doTheVenclextaLogic = (hasVenclexta, outsideConsentValue, ctx) => {
    //Common Fields
    // new physicican consent data names
    //const cField1 = 'Signature Physician Consent';
    //const cField2 = 'Signature Physician or Authorized Person Consent Canvas';
    //const cField3 = 'Signature Physician Name of Signor';
    //const cField4 = 'Signature Physician Consent Date';

    //const alwaysRequiredFields = [cField1, cField2, cField3, cField4]


    //Venclexta Fields
    const vField1 = 'Patient Best Time to Call';
    const vField2 = 'Medical GenentechHub Venclexta Condition';

    //education consent
    const vField5 = 'Signature Patient Resource Venclexta';
    const vField6 = 'Signature Patient or Authorized Education Canvas';
    const vField7 = 'Signature Patient Education Date';
    const vField8 = 'Signature Patient TCPA Consent Venclexta';
    const vField9 = 'Signature Patient Resource Consent Venclexta';
    const vField10 = 'Signature AbbVie Products';



    const venclextaFields = [vField1, vField2, vField5, vField6, vField7, vField8, vField9, vField10];


    //venclexta required

    //Pat consent
    const vField11 = 'Signature Patient Consent Venclexta';
    const vField12 = 'Signature Patient or Authorized Person Consent Canvas';
    const vField13 = 'Signature Patient Consent Date';
    const vField14 = 'Signature Patient Consent Relationship of Signor';
    const vField15 = 'Signature Patient Consent Name of Signor';

    const vField16 = 'Signature Terms and Conditions Venclexta';

    //Financial
    const vField19 = 'Signature Patient Financial Eligibility Venclexta';
    const vField20 = 'Signature Financial Patient or Authorized Person Consent Canvas';
    const vField21 = 'Signature Financial Patient Consent Date';

    //venclexta always required internal or external

    //vencompass
    const vField17 = 'Signature Venclexta Vencompass Consent';
    const vField18 = 'Signature Vencompass';   // required? yes



    const requiredVenclextaFields = [vField11, vField12, vField13, vField14, vField15, vField16, vField17, vField18, vField19, vField20, vField21];
    const externalRequiredVenclextaFields = [vField17, vField18];



    //nonven

    //terms and condition
    const nvField1 = 'Signature Terms and Conditions';
    //financial
    const nvField2 = 'Signature Patient Financial Eligibility';
    //edu
    const nvField3 = 'Signature Patient Resource';
    const nvField4 = 'Signature Patient Resource Consent';
    const nvField5 = 'Signature Patient TCPA Consent';
    //patient
    const nvField6 = 'Signature Patient Consent';

    const notVenclextaFields = [nvField1, nvField2, nvField3, nvField4, nvField5, nvField6];

    //nonven required

    const nvField7 = 'Signature Patient Consent Checkbox';
    const requiredNotVenclextaFields = [nvField7];

    const externalInstructions = 'Signature Method of Patient Consent';  //instructions to fill out consents online, needs to be hidden if internal consent
    const hideInstructions = [externalInstructions];



    const nreqField1 = 'Income Genentech Gross Yearly Household Income';
    const variableRequiredFields = [nreqField1];
    const lmField1 = 'Patient OK To Leave Message';
    const lmField2 = 'Patient OK To Leave Message Venclexta';
    const detailedMgsField = [lmField1];
    const detailedMgsVenclextaField = [lmField2];




    //always required physician and patient consent method
    //ctx.specialRulePerformAction('show', alwaysRequiredFields);
    //ctx.specialRulePerformAction('require', alwaysRequiredFields);

    if (hasVenclexta) {
        //gross inccome, required for nonVen, optional for Ven
        ctx.specialRulePerformAction('unrequire', variableRequiredFields);
        ctx.specialRulePerformAction('hide', detailedMgsField);
        ctx.specialRulePerformAction('show', detailedMgsVenclextaField);



        //venclexta
        ctx.specialRulePerformAction('unrequire', requiredNotVenclextaFields);
        ctx.specialRulePerformAction('hide', [...notVenclextaFields, ...requiredNotVenclextaFields]);
        ctx.specialRulePerformAction('show', [...venclextaFields, ...requiredVenclextaFields]);





        //external
        if (outsideConsentValue === 'Yes') {
            ctx.specialRulePerformAction('unrequire', venclextaFields);
            ctx.specialRulePerformAction('unrequire', requiredVenclextaFields);
            ctx.specialRulePerformAction('require', externalRequiredVenclextaFields);
            //show consent instructions
            ctx.specialRulePerformAction('show', hideInstructions);
        }
        else {
            //internal
            ctx.specialRulePerformAction('require', requiredVenclextaFields);
            ctx.specialRulePerformAction('unrequire', requiredNotVenclextaFields);
            ctx.specialRulePerformAction('hide', [...notVenclextaFields, ...requiredNotVenclextaFields]);
            //hide consent instructions
            ctx.specialRulePerformAction('hide', hideInstructions);
        }

    }
    else {
        //nonvenclexta/

        //gross inccome, required for nonVen, optional for Ven
        ctx.specialRulePerformAction('require', variableRequiredFields);
        //leave detailed msgfield
        ctx.specialRulePerformAction('show', detailedMgsField);
        ctx.specialRulePerformAction('hide', detailedMgsVenclextaField);

        ctx.specialRulePerformAction('unrequire', requiredVenclextaFields);
        ctx.specialRulePerformAction('hide', [...venclextaFields, ...requiredVenclextaFields]);
        ctx.specialRulePerformAction('show', [...notVenclextaFields, ...requiredNotVenclextaFields]);
        ctx.specialRulePerformAction('require', requiredNotVenclextaFields);
        //external
        if (outsideConsentValue === 'Yes') {
            ctx.specialRulePerformAction('unrequire', requiredNotVenclextaFields);
            ctx.specialRulePerformAction('hide', [...notVenclextaFields, ...requiredNotVenclextaFields]);
            //show consent instructions
            ctx.specialRulePerformAction('show', hideInstructions);
        }
        else {
            //internal
            ctx.specialRulePerformAction('show', [...notVenclextaFields, ...requiredNotVenclextaFields]);
            ctx.specialRulePerformAction('require', requiredNotVenclextaFields);
            //hide consent instructions
            ctx.specialRulePerformAction('hide', hideInstructions);
        }
    }

}
//ves fix for nonven
export const genentechHubSignorName = (value, ctx) => {
    const field = 'Signature Patient Consent Name of Signor';
    const outsideConsentValue = ctx.formData['Signature Consent Outside of AssistPoint'];
    /*const relationshipValue = ctx.formData['Signature Patient Consent Relationship of Signor'];*/

    if (value === 'Self' && (outsideConsentValue === 'Yes')) {
        ctx.specialRulePerformAction('unrequire', [field]);
        ctx.specialRulePerformAction('hide', [field]);
    }
    else if (value === 'Self' && (outsideConsentValue === 'No')) {
        ctx.specialRulePerformAction('unrequire', [field]);
        ctx.specialRulePerformAction('hide', [field]);

    }
    else if (value !== 'Self' && (outsideConsentValue === 'Yes')) {
        ctx.specialRulePerformAction('unrequire', [field]);
        ctx.specialRulePerformAction('show', [field]);
    }
    else if (value !== 'Self' && (outsideConsentValue === 'No')) {
        ctx.specialRulePerformAction('require', [field]);
        ctx.specialRulePerformAction('show', [field]);

    }
    else {
        // will never fire, all possible combos accounted for above
        ctx.specialRulePerformAction('require', [field]);
        ctx.specialRulePerformAction('show', [field]);
    }
}

/***********************************************************
 End of Genentech Hub Attestation & Signatures Rules
 ***********************************************************/

export const createGenentechHubRules = (meta, ctx) => {
    ctx.createSpecialRule("GenentechHub Pharmacy Details", venclextaSpecialRule);
    ctx.createSpecialRule("Insurance Does Patient Have Primary Medical Insurance", genentechHubInsurance);
    ctx.createSpecialRule("Insurance Does Patient Have Secondary Medical Insurance", genentechHubInsurance);
    ctx.createSpecialRule("Other GenentechHub Eligibilty Reason", genentechHubInsurance);
    ctx.createSpecialRule("Signature Consent Outside of AssistPoint", genentechHubSignatures);
    ctx.createSpecialRule("Signature Patient Consent Relationship of Signor", genentechHubSignorName);
    initVenclextaSpecialRule(ctx);
}